import React, { PureComponent } from "react";
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel";
import styled from "styled-components";

import Emoji from "../Emoji/Emoji";

const EmojiContainer = styled.div`
  cursor: pointer;
  font-size: 30px;
  border: 5px solid ${props => (props.color ? props.color : "#CCC")};
  background-color: white;
  text-align: center;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
  height: 50px;
  white-space: nowrap;
`;

class EmojiMarker extends PureComponent {
  render() {
    const { emoji, onClick, infoWindowVisible, color } = this.props;
    return (
      <MarkerWithLabel
        key={emoji.id}
        position={{ lat: emoji.lat, lng: emoji.lng }}
        labelAnchor={new window.google.maps.Point(48, 48)}
        labelStyle={{
          fontSize: "48px"
        }}
        icon={{
          url: require("./empty.png"),
          scale: 10
        }}
        onClick={() => onClick(!infoWindowVisible)}
      >
        <React.Fragment>
          <EmojiContainer color={color}>
            <Emoji>{emoji.emoji}</Emoji>
          </EmojiContainer>
          {this.props.children}
        </React.Fragment>
      </MarkerWithLabel>
    );
  }
}

export default EmojiMarker;



// WEBPACK FOOTER //
// ./src/components/EmojiMarker/EmojiMarker.js